class ShipmentsNotifications {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  sendLabels(shipmentReference, email, message) {
    return this.apiClient.post(`/v1/notifications/shipments/${shipmentReference}/label`, {
      email,
      message
    }).then(response => response.data);
  }

  /**
   * @deprecated will be replaced by Packlink.v1.shipments.cancelShipment
   */
  cancelShipment(shipment, publicComment, ticketSubject) {
    return this.apiClient.post('/v1/notifications/cancel_shipment', {
      ...shipment.getCancelPayload(),
      public_comment: publicComment,
      ticket_subject: ticketSubject
    }).then(response => response.data);
  }
}

export { ShipmentsNotifications };
//# sourceMappingURL=Shipments.js.map
